import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:opacity-80 transition-opacity whitespace-nowrap"
          >
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold tracking-tight">今日看料</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`hidden md:flex px-4 py-2 text-sm rounded-full transition-all whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-3 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-3 text-sm rounded-lg text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}